import type { LangCode, PlanDefault_EditPageQuery } from "@/lib/gql/__generated__/graphql";

import { useTransitionBlock } from "@/hooks/use-transition-block";

import { NameOfResourceBeingEdited } from "@/components/features/_components";
import type { FeatureIslandHeaderLangNavigatorProps } from "@/components/features/_layouts";
import {
	FeatureIslandContainer,
	FeatureIslandHeader,
	FeatureIslandMainWithCategory,
} from "@/components/features/_layouts";

import { HeaderActions } from "./header/actions";
import { useInitialized } from "../../../model/usecase/existing/use-init";
import { PlanFormMain } from "../../_shared/components/root";
import { planCategoriesAndManagerStore } from "../../_shared/store/categories";
import { ProductExistingPlanFormModelContextProvider } from "../context";

type Props = {
	activeLangCode: LangCode;
	navigator: FeatureIslandHeaderLangNavigatorProps;
	serverModel: PlanDefault_EditPageQuery;
};

export const PlanEditPresenter = ({ serverModel, activeLangCode, navigator }: Props) => {
	const init = useInitialized({ serverModel });

	const { isDirty } = init.viewModel;
	useTransitionBlock(isDirty);

	const { categoryManagerStore } = planCategoriesAndManagerStore;
	const planName = init.viewModel.name.value;

	return (
		<ProductExistingPlanFormModelContextProvider value={{ ...init }}>
			<FeatureIslandContainer>
				<FeatureIslandHeader
					title="プラン編集"
					activeLangCode={activeLangCode}
					navigator={navigator}
					rightChildren={<HeaderActions />}
				/>
				<FeatureIslandMainWithCategory categoryManagerStore={categoryManagerStore}>
					{/* @todo Layout の共通化が出来るまでは共通化しない */}
					<NameOfResourceBeingEdited resourceName={planName} />

					<PlanFormMain planCategoriesAndManagerStore={planCategoriesAndManagerStore} />
				</FeatureIslandMainWithCategory>
			</FeatureIslandContainer>
		</ProductExistingPlanFormModelContextProvider>
	);
};

PlanEditPresenter.displayName = "PlanEditPresenter";
